import React, {useEffect, useState} from 'react'
import MainPage from "./decay_sim_main";
import DownloadPage from "./decay_sim_download";
import {Media, Pages} from "./decay_sim_data";
import {PageTitles, SitePages} from "../../SitePages"

import s from "./decay_sim_style.module.css"
import {BackgroundVideo} from "../../components/backgroundVideo";
import {MicrobeBackButton} from "../../components/microbeBackButton";
import {Images} from "../../AssetReferences";
import {useNavigate} from "react-router-dom";
import {useTitle} from "../../hooks/UseTitle";

export default function DecaySim({})
{
    const [section, setSection] = useState(Pages.Main)
    
    const navigate = useNavigate();
    useTitle(PageTitles.DecaySim)
    
    function onExit(){
        navigate(`../${SitePages.Home}`);
    }
    
    function getAlpha()
    {
        switch (section)
        {
            case Pages.Main: return 1;
            case Pages.Download: return 0.6;
            default: return 1;
        }
    }

    return (
        <div className={s.decay_sim}> 
            {/*<video src={Media.BackgroundVideo} autoPlay={true} controls={true}/>*/}
            
            <BackgroundVideo
                src={Media.BackgroundVideo}
                loop={true}
                />
            
            <MicrobeBackButton 
                image_src={Images.George}
                tooltip={"Click to go back to homepage"}
                onClick={onExit}
                top={2}
                left={2}
                size={5}
                />

            <div className={s.column_container}>
                <div className={s.column} style={{backgroundColor: "rgb(229,240,246," + getAlpha() + ")"}}>
                    <div style={{width: "18em"}}>
                        <img src={Media.DecaySimTitle}
                             alt={"Decay Sim"}
                             width={"100%"}/>
                    </div>

                    <LilRotatingBoy src={Media.FrameIcon}/>
                    
                    <DisplayPage/>
                    
                </div>    
            </div>
        </div>
    )
    
    function OpenPage (page) {
        setSection(page);
    }
    
    function DisplayPage({})
    {
        switch (section)
        {
            case Pages.Main: return <MainPage onDownloadButtonPressed={() => OpenPage(Pages.Download)}/>
            case Pages.Download: return <DownloadPage onBackButtonPressed={() => OpenPage(Pages.Main)}/>
            
            default: return <p>❗ DisplayPage called with unknown section: {section}</p>
        }
    }
}


function LilRotatingBoy({src}) {
    return (
        <div id={"lilRotatingVideoGuy"} className={s.lil_rotating_boy}>
            <img style={{width: "100%"}} src={src} alt={"frame icon"}/>
        </div>
    )
}


export function PageButton({onClick, text})
{
    return (
        <div className={s.page_btn_box} >
            <a className={s.page_btn} onClick={onClick} href={"#"}>{text}</a>
        </div>
    )
}